/**
 * Picks v2 or v1 of the Background Music page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import BackgroundMusicPage   from './BackgroundMusicPage';
import BackgroundMusicPageV2 from './BackgroundMusicPageV2';

export default function BackgroundMusicPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? BackgroundMusicPageV2 : BackgroundMusicPage;
  return <Component {...props} />;
}
